"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isString = exports.isPlainObject = exports.isObject = exports.isNil = exports.isFunction = exports.isError = exports.isEqual = exports.isEmpty = exports.isDeepEqual = exports.isBoolean = exports.default = void 0;
exports.normalizeError = normalizeError;
var isBoolean = require('lodash.isboolean');
exports.isBoolean = isBoolean;
var isEmpty = require('lodash.isempty');
exports.isEmpty = isEmpty;
var isEqual = require('lodash.isequal');
exports.isEqual = isEqual;
var isError = require('lodash.iserror');
exports.isError = isError;
var isFunction = require('lodash.isfunction');
exports.isFunction = isFunction;
var isNil = require('lodash.isnil');
exports.isNil = isNil;
var isObject = require('lodash.isobject');
exports.isObject = isObject;
var isPlainObject = require('lodash.isplainobject');
exports.isPlainObject = isPlainObject;
var isString = require('lodash.isstring');
exports.isString = isString;
var isDeepEqual = isEqual;
exports.isDeepEqual = isDeepEqual;
function normalizeError(error) {
  if (error instanceof Error) return error;
  if (isString(error)) return new Error(error);
  if (isString(error.message)) return new Error(error.message);
  return new Error(String(error));
}
var _default = {
  isBoolean,
  isDeepEqual,
  isEmpty,
  isEqual,
  isError,
  isFunction,
  isNil,
  isObject,
  isPlainObject,
  isString,
  normalizeError
};
exports.default = _default;